interface TermsSection {
  title: string;
  data: string[];
}

export const TERMS_AND_CONDITION_SECTIONS: TermsSection[] = [
  {
    title: '1. Initial provisions',
    data: [
      '1.1. These personal data protection principles describe the manner of obtaining, using and further handling ' +
        'of personal data obtained via https://www.divesoft.com.'
    ]
  },
  {
    title: '2. Controller',
    data: [
      'The personal data controller is: Divesoft s.r.o. Comp. Reg. No. 267 22 101 having its registered office at K ' +
        'Haltýři 756/14, Troja, 181 00 Praha 8 maintained by the Municipal Court in Prague under file No. C 89580'
    ]
  },
  {
    title: '3. Legislation',
    data: [
      'When handling personal data we proceed in accordance with the Czech Republic legislation and directly ' +
        'applicable European Union regulations, in particular by the Regulation (EU) 2016/679 of the European ' +
        'Parliament and the Council of 27 April 2016 on the protection of natural persons with regard to the ' +
        'processing of personal data and on the free movement of such data and repealing Directive 95/46/EC, as ' +
        'amended (hereinafter "GDPR").'
    ]
  },
  {
    title: '4. Obtaining personal data ',
    data: [
      'You give your personal data to us in particular when setting up a user account. If there is any change in ' +
        'your personal data, inform us please. When visiting and using a web interface, further personal data may be ' +
        'obtained and stored using cookies.'
    ]
  },
  {
    title: '5. Personal data',
    data: [
      '5.1. During registration you provide us with the following personal data:',
      'a) first name and surname',
      'b) e-mail address'
    ]
  },
  {
    title: '6. Purpose of personal data processing',
    data: [
      '6.1. The purpose of personal data processing is:',
      'a) contract performance – provide a service and in case of registration for allowing access, administration ' +
        'and management of a user account. This data processing is based on Article',
      'b) GDPR and serves for performing a contract. b) purposes of the legitimate interests – sending commercial ' +
        'messages (newsletters) about our goods and services to those who purchased our goods or set up a user ' +
        'account and agreed with sending of commercial messages. Commercial messages relate mainly to news in our ' +
        'business assortment and discount. Commercial messages are sent to your e-mail and you can revoke it at any ' +
        'time. This data processing is based on Article 6 (1) (f) GDPR and serves to our legitimate interest.',
      'c) given consent – sending the aforementioned commercial messages to those who signed up for their ' +
        'subscription without having purchased any good or services or set up a user account. Commercial messages ' +
        'are sent to your e-mail and you can revoke it at any time. This data processing is based on Article 6 (1) ' +
        '(a) and Article 7 of the GDPR.'
    ]
  },
  {
    title: '7. Personal data processing for sending commercial messages',
    data: [
      '7.1. If you are our customer, we have a legitimate interest for sending our commercial messages, because we ' +
        'reasonably believe that you are interested in our news. If you are not our customer, we will only send you ' +
        'commercial messages with your consent.',
      '7.2. In order for us to be able to send you our commercial messages on current products, discount offers, ' +
        'accessories offers or consumable material to already purchased products, we process the following personal ' +
        'data: first name and surname and e-mail address.',
      '7.3. The aforementioned personal data will not be provided to third parties except for e-mail services ' +
        'provider which provides bulk sending of the newsletter. The provider has clearance for secure personal data ' +
        'processing and has undertaken to observe the regulation. The provider is located in the United States of ' +
        'America and is registered in the EU-USA privacy shield.',
      '7.4. The EU-USA privacy shield is available at: https://www.privacyshield.gov. The European Commission issued ' +
        'a decision on adequate protection in relation to this shield, in the mode under Article 45(9) GDPR, ' +
        'therefore such transmission of personal data does not require a special permission.',
      '7.5. You can revoke sending of commercial messages at any time by using the link provided in each our ' +
        'newsletter e-mail or by using the settings of your account or any time when you order our goods.'
    ]
  },
  {
    title: '8. Processing duration',
    data: [
      '8.1. For the duration of mutual contractual relation or for a period set by legal regulations.',
      '8.2. Personal data for the purpose of sending commercial messages and for the period for which you are ' +
        'subscribed and 3 years after you have unsubscribed.'
    ]
  },
  {
    title: '9. Your rights',
    data: [
      '9.1. As the data subject you have all rights arising from generally binding legal regulations for protection ' +
        'of personal data, in particular the right to:',
      'a) recall consent with personal data processing,',
      'b) access to personal data',
      'c) personal data rectification',
      'd) personal data deletion',
      'e) limitation of personal data processing',
      'f) raise objection against personal data processing',
      'g) transfer personal data to other controller',
      'h) file a complaint with the Office for Personal Data Protection if you believe that the controller proceeds ' +
        'contrary to generally binding legal regulations for personal data protection when processing personal data.'
    ]
  },
  {
    title: '10. Processors',
    data: [
      '10.1. We use personal data processors which provide personal data processing.',
      '10.2. The processors process data solely upon our instructions, we concluded contract for personal data ' +
        'processing with them and they are obliged to maintain generally binding legal regulations for personal data ' +
        'protection.',
      '10.3. All processors have been carefully selected and they will have access to your personal data only in the ' +
        'scope and for time period necessary for provision of a service or in the scope in which you allowed ' +
        'processing and using personal data.'
    ]
  },
  {
    title: '11. Personal data security',
    data: [
      '11.1. We undertook to adopt such measures to prevent from unauthorized or accidental access to personal data, ' +
        'their change, destruction or loss, unauthorized transmissions, or other unauthorized processing, as well as ' +
        'other personal data misuse. This obligation will survive termination of employment or contractual relation.',
      '11.2. Our employees or other natural persons processing personal data based on a contract, and other persons, ' +
        'are obliged to keep in confidentiality all personal data, even after termination of employment or ' +
        'contractual relation.'
    ]
  },
  {
    title: '12. Cookies',
    data: [
      '12.1. Cookies are text files stored in a computer or other electronic device of each visitor ' +
        'https://www.divesoft.com/, which allow functioning of a web interface. It is a small amount of data which a ' +
        'viewed webpage sends to your device where it is stored. When you visit the previously viewed webpage next ' +
        'time it will use the stored cookies to identify whether you have visited the page already and what parts of ' +
        'the web you are viewing. Cookies also allow you to save your settings.',
      '12.2. Not all cookies collect personal data. Certain cookies only allow correct functioning of web interface. ' +
        'You can refuse to use cookies by selecting the relevant setting in your browser.',
      '12.3. Note that if you refuse cookies you will not be able to finish your order.',
      '12.4. The webpage interface uses these services working with information obtained through cookies: Google ' +
        'Analytics and possibly other services provided by Google, Inc and Facebook Pixel provided by Facebook Inc.'
    ]
  },
  {
    title: '13. Contact',
    data: [
      '13.1. Please use the below contacts for all questions concerning personal data processing:',
      'Divesoft s.r.o., with the registered office at K Haltýři 756/14, Troja, 181 00 Praha 8',
      'Web: https://www.divesoft.com/',
      'E-mail: info@divesoft.com',
      'Telephone: +420 416 857 057'
    ]
  }
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/terms.ts